import { put, takeEvery } from "redux-saga/effects";
import { GET_CONTACT, SET_CONTACT } from "../ConstAction";
import ContactApiRequests from "../../Services/Contact";
import { toast } from "react-toastify";
function* getContact(data) {
  console.log(data);

  try {
    let response = yield ContactApiRequests.requestcontact(data.data);
    if (response.status)
      toast.success("Email sent successfully.")
    yield put({
      type: SET_CONTACT,
      response,
      loading: false
    });
  } catch (err) { }
}
function* contactSaga() {
  yield takeEvery(GET_CONTACT, getContact);
}
export default contactSaga;
